"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactCollapsible = _interopRequireDefault(require("react-collapsible"));
var _lodash = require("lodash");
var _faSync = require("@fortawesome/free-solid-svg-icons/faSync");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var Status = _interopRequireWildcard(require("chaire-lib-common/lib/utils/Status"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _utils = require("../../../services/ui/utils");
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
var _Chart = _interopRequireDefault(require("../../graph/Chart"));
var _columnChartOptions = _interopRequireDefault(require("../../graph/columnChartOptions"));
var _distributionChartOptions = _interopRequireDefault(require("../../graph/distributionChartOptions"));
var _localStorageManager = require("../../../services/ui/localStorageManager");
var _PeriodCount = _interopRequireDefault(require("./PeriodCount.widget"));
var _WidgetOptionsSelector = _interopRequireDefault(require("./WidgetOptionsSelector"));
var _OctaviComponent = require("./OctaviComponent.widget");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class TotalCountWidget extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "addFilterFileName", (fileName, filter) => {
      const dates = (0, _utils.getDatesForPeriodAggregation)(filter['calendarStartAt'], filter['calendarEndAt'], this.state.widgetOptions.temporalOption);
      const startString = (0, _momentTimezone.default)(dates['periodStart']).format("YYYYMMDD");
      const endString = (0, _momentTimezone.default)(dates['periodEnd']).format("YYYYMMDD");
      fileName += '-' + startString + "_" + endString;
      if (filter.temporalFilterIsSelected === true) {
        if (filter.dayIsSelected === true) {
          const daysString = (filter.dayChoices || []).map(day => this.props.t(`octavi:filters:temporal:day_:${day}`).substr(0, 2)).join('');
          if (daysString !== '') {
            fileName += '_' + daysString;
          }
        }
        if (filter.hourIsSelected === true) {
          const hours = (filter.hourChoices || []).filter(hour => hour !== 'other');
          const customHours = filter.hourCustomChoices || [];
          hours.push.apply(hours, (0, _toConsumableArray2.default)(customHours));
          if (hours.length !== 0) {
            fileName += '_' + hours.join('&');
          }
        }
      }
      if (filter.spatialFilterIsSelected === true) {
        if (filter.originIsSelected === true && (filter.selectedOriginDistricts || []).length > 0) {
          fileName += '_O' + filter.selectedOriginDistricts.length + 'zones';
        }
        if (filter.destinationIsSelected === true && (filter.selectedDestinationDistricts || []).length > 0) {
          fileName += '_D' + filter.selectedDestinationDistricts.length + 'zones';
        }
      }
      return fileName;
    });
    (0, _defineProperty2.default)(this, "clearValueFilter", (filterName, graphState) => {
      const dataType = graphState ? "totalCountGraph" : "totalCount";
      const widgetOptions = _OctaviParameters.default.get(`selectedWidgets.${this.props.uuid}.options`, {});
      const filterKey = (0, _localStorageManager.getLocalStorageKey)(this.state.filters, filterName, widgetOptions);
      (0, _localStorageManager.clearLocalStorageForFilter)(filterKey, this.props.object, dataType);
    });
    (0, _defineProperty2.default)(this, "onRefreshClick", () => {
      const graphState = _OctaviParameters.default[`${this.props.uuid}widgetChartIsActive`] !== undefined ? _OctaviParameters.default[`${this.props.uuid}widgetChartIsActive`] : this.state.widgetChartIsActive;
      // Make sure to reset the data in the local storage before
      this.clearValueFilter('FilterOne', graphState);
      if (_OctaviParameters.default.comparisonIsSelected) {
        this.clearValueFilter('FilterTwo', graphState);
      }

      // Reset the values to load again
      this.setState({
        value0: null,
        value1: null
      }, () => {
        this.updateTimeRange();
      });
    });
    this.state = {
      detailOpen: false,
      widgetChartIsActive: _OctaviParameters.default.get(`${this.props.uuid}widgetChartIsActive`, false),
      widgetOptions: (_OctaviParameters.default.selectedWidgets[this.props.uuid] || {}).options || {},
      comparisonIsSelected: _OctaviParameters.default.get('comparisonIsSelected', false),
      // TODO Not an array because each value is updated independently. This avoids state update race condition. But each filter's data should be in its own widget, with its own state
      value0: null,
      value1: null,
      filters: _OctaviParameters.default.filters
    };
    this.onChartButtonClick = this.onChartButtonClick.bind(this);
    this.onSettingsButtonClick = this.onSettingsButtonClick.bind(this);
    this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
    this.updateTimeRange = this.updateTimeRange.bind(this);
    this.updateComparisonSelection = this.updateComparisonSelection.bind(this);
    this.updateWidgetOptions = this.updateWidgetOptions.bind(this);
    this.getWidgetTitleType = this.getWidgetTitleType.bind(this);
    this.onDetailOpening = this.onDetailOpening.bind(this);
    this.onDetailClose = this.onDetailClose.bind(this);
  }
  componentDidMount() {
    //connect to filter modification
    _ServiceLocator.default.eventManager.on('taxi.filter.submit', this.updateTimeRange);
    //connect to widget status modification
    _ServiceLocator.default.eventManager.on(`taxi.widget.${this.props.uuid}widgetChartStatus.update`, this.updateTimeRange);
    //connect widget to comparision
    _ServiceLocator.default.eventManager.on('taxi.filter.comparisonIsSelected.update', this.updateComparisonSelection);
    //connect widget to options
    _ServiceLocator.default.eventManager.on(`taxi.widget.${this.props.uuid}SelectOptions.update`, this.updateWidgetOptions);
    this.updateTimeRange();
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.filter.submit', this.updateTimeRange);
    _ServiceLocator.default.eventManager.off(`taxi.widget.${this.props.uuid}widgetChartStatus.update`, this.updateTimeRange);
    _ServiceLocator.default.eventManager.off('taxi.filter.comparisonIsSelected.update', this.updateComparisonSelection);
    _ServiceLocator.default.eventManager.off(`taxi.widget.${this.props.uuid}SelectOptions.update`, this.updateWidgetOptions);
  }
  onChartButtonClick() {
    const oldState = this.state.widgetChartIsActive;
    this.setState({
      widgetChartIsActive: !oldState,
      value0: null,
      value1: null
    });
    _OctaviParameters.default[`${this.props.uuid}widgetChartIsActive`] = !oldState;
    _ServiceLocator.default.eventManager.emit(`taxi.widget.${this.props.uuid}widgetChartStatus.update`);
  }
  onSettingsButtonClick() {
    _ServiceLocator.default.eventManager.emit(`taxi.widget.${this.props.uuid}ManageOptions.request`);
  }
  onDeleteButtonClick() {
    _ServiceLocator.default.eventManager.emit('taxi.filter.selectedWidgets.delete', this.props.uuid);
  }
  updateComparisonSelection() {
    this.setState({
      comparisonIsSelected: _OctaviParameters.default.comparisonIsSelected
    });
    this.updateTimeRange();
  }
  updateWidgetOptions() {
    this.setState({
      widgetOptions: _OctaviParameters.default.get(`selectedWidgets.${this.props.uuid}.options`, {})
    });
    this.updateTimeRange();
  }
  updateValueFilter(graphState, requestOption, filterName) {
    const filterIdx = (0, _utils.getFilterIdx)(this.state.filters, filterName);
    const widgetOptions = _OctaviParameters.default.get(`selectedWidgets.${this.props.uuid}.options`, {});
    const filterKey = (0, _localStorageManager.getLocalStorageKey)(this.state.filters, filterName, widgetOptions);
    const dataType = graphState ? "totalCountGraph" : "totalCount";
    const Action = this.props.object.charAt(0).toUpperCase() + this.props.object.slice(1) + dataType.charAt(0).toUpperCase() + dataType.slice(1);

    // Load data from locale storage
    const progressString = this.props.t(`notifications:OctaviLoading${Action}`, {
      n: filterName === 'FilterOne' ? 1 : 2
    });
    _ServiceLocator.default.eventManager.emit('progress', {
      name: progressString,
      progress: 0
    });
    const result = (0, _localStorageManager.loadLocalStorageFromFilter)(filterKey, this.props.object, dataType);

    // data already existing in locale storage
    if (result) {
      this.setState({
        [`value${filterIdx}`]: result
      });
      _ServiceLocator.default.eventManager.emit('progress', {
        name: progressString,
        progress: 1
      });
    }
    // data doesn't exist in locale storage, need to import and compute data
    else {
      const dates = (0, _utils.getDatesForPeriodAggregation)(this.state.filters[filterIdx]['calendarStartAt'], this.state.filters[filterIdx]['calendarEndAt'], widgetOptions.temporalOption);
      const startAt = dates['periodStart'].tz('utc').unix();
      const endAt = dates['periodEnd'].tz('utc').unix();
      _ServiceLocator.default.socketEventManager.emit(`taxi.totalCount.${requestOption}timeRange`, {
        object: this.props.object,
        customFilterString: this.props.customFilterString ? this.props.customFilterString : "",
        dataSourceIds: _OctaviParameters.default.dataSourceIds,
        startAt: startAt,
        endAt: endAt,
        filters: (0, _utils.buildWidgetFilter)(this.state.filters, filterName, this.props.object, widgetOptions),
        type: this.props.type,
        widgetSpecs: this.props.widgetSpecs
      }, function (responseStatus) {
        let requestResult;
        if (Status.isStatusOk(responseStatus)) {
          const response = Status.unwrap(responseStatus);
          requestResult = graphState ? response : response.status === 'no_data' ? 'no_data' : response.count;
          (0, _localStorageManager.saveLocalStorageDataFromFilter)(filterKey, this.props.object, requestResult, dataType);
        } else {
          // error status, set NaN for count
          requestResult = graphState ? {
            status: 'error'
          } : Number.NaN;
        }
        this.setState({
          [`value${filterIdx}`]: requestResult
        });
        _ServiceLocator.default.eventManager.emit('progress', {
          name: progressString,
          progress: 1
        });
      }.bind(this));
    }
  }
  updateTimeRange() {
    // this is needed because when updateTimeRange for the first time, octaviParameters.activeDriverCountWidgetChart is not defined yet
    // and when pushing button state is not up to date
    const graphState = _OctaviParameters.default[`${this.props.uuid}widgetChartIsActive`] !== undefined ? _OctaviParameters.default[`${this.props.uuid}widgetChartIsActive`] : this.state.widgetChartIsActive;
    let requestOption = "";
    if (graphState) {
      const latesOptions = _OctaviParameters.default.get(`selectedWidgets.${this.props.uuid}.options`, {});
      if (latesOptions.graphOption && latesOptions.graphOption === "objectDistribution") {
        requestOption = "byObject.";
      } else if (latesOptions.graphOption && latesOptions.graphOption === "spatialDistribution") {
        requestOption = "byZone.";
      } else {
        requestOption = "byPeriod.";
      }
    }
    const newFilters = _OctaviParameters.default.filters;
    const idxFilterOne = (0, _utils.getFilterIdx)(newFilters, 'FilterOne');
    const idxFilterTwo = (0, _utils.getFilterIdx)(newFilters, 'FilterTwo');

    //we only updqte filters if dates are not null
    if (newFilters[idxFilterOne]['calendarStartAt'] && newFilters[idxFilterOne]['calendarEndAt']) {
      // we start by init value to null to relaunch loading page
      this.setState({
        value0: null,
        value1: null,
        filters: newFilters
      }, function () {
        this.updateValueFilter(graphState, requestOption, "FilterOne");
        if (_OctaviParameters.default.comparisonIsSelected && this.state.filters[idxFilterTwo]['calendarStartAt'] && this.state.filters[idxFilterTwo]['calendarEndAt']) {
          this.updateValueFilter(graphState, requestOption, "FilterTwo");
        }
      }.bind(this));
    }
  }
  getWidgetTitleType() {
    if (this.state.widgetOptions.objectOption && !(0, _LodashExtensions._isBlank)(this.state.widgetOptions.objectOption) && this.state.widgetOptions.objectOption !== "none" || this.state.widgetOptions.temporalOption && !(0, _LodashExtensions._isBlank)(this.state.widgetOptions.temporalOption) && this.state.widgetOptions.temporalOption !== "none") {
      return "mean";
    } else {
      return "count";
    }
  }
  addOptionsTitle(title, isObjectOptionNotNull, isTemporalOptionNotNull, isGeographicalOptionNotNull, isStatusOptionNull) {
    if (isObjectOptionNotNull) {
      title += " " + this.props.t(`octavi:widgetOptions:objectOption:${this.state.widgetOptions.objectOption}`).toLowerCase();
    }
    if (isGeographicalOptionNotNull) {
      title += " " + this.props.t(`octavi:widgetOptions:geographicalOption:${this.state.widgetOptions.geographicalOption}`).toLowerCase();
      title += " (" + this.props.t(`octavi:widgetOptions:onLocationOption:${this.state.widgetOptions.onLocationOption}`).toLowerCase() + ")";
    }
    if (isStatusOptionNull && this.props.object !== 'trips') {
      if (this.state.widgetOptions.statusOption === 'occupied') {
        // Special option title for trips instead of status 'occupied'
        title += " " + this.props.t(`octavi:widgetOptions:statusOption:trips`);
      } else {
        title += " " + this.props.t(`octavi:widgetOptions:statusOption:titleFirstPart`) + " " + this.props.t(`octavi:widgetOptions:statusOption:${this.state.widgetOptions.statusOption}`).toLowerCase();
      }
    }
    if (isTemporalOptionNotNull) {
      title += " " + this.props.t(`octavi:widgetOptions:temporalOption:${this.state.widgetOptions.temporalOption}`).toLowerCase();
    }
    return title;
  }
  addOptionFileName(fileName, isObjectOptionNotNull, isTemporalOptionNotNull, isGeographicalOptionNotNull, isStatusOptionNull) {
    if (isObjectOptionNotNull) {
      fileName += " " + this.props.t(`octavi:widgetOptions:objectOption:${this.state.widgetOptions.objectOption}`);
    }
    if (isGeographicalOptionNotNull) {
      fileName += " " + this.props.t(`octavi:widgetOptions:geographicalOption:file:${this.state.widgetOptions.geographicalOption}`);
      fileName += " " + this.props.t(`octavi:widgetOptions:onLocationOption:file:${this.state.widgetOptions.onLocationOption}`);
    }
    if (isStatusOptionNull) {
      fileName += " " + this.props.t(`octavi:widgetOptions:statusOption:${this.state.widgetOptions.statusOption}`);
    }
    if (isTemporalOptionNotNull) {
      fileName += " " + this.props.t(`octavi:widgetOptions:temporalOption:${this.state.widgetOptions.temporalOption}`).toLowerCase();
    }
    return fileName;
  }
  /**
   * @params periodStringName name of periode (i.e sur la periode, sur la semaine, sur le mois....)
   * @parmas titleType (optional) type of widget (i.e. mean, chart, sum...)
   *
   *@return retunrs a list with name where elt 0 is widget name; elt 1 is graph name
   */
  getTitle(periodStringName, titleType = null) {
    //geting first part of the title
    const isObjectOptionNotNull = !(0, _LodashExtensions._isBlank)(this.state.widgetOptions.objectOption) && this.state.widgetOptions.objectOption !== "none";
    const isTemporalOptionNotNull = !(0, _LodashExtensions._isBlank)(this.state.widgetOptions.temporalOption) && this.state.widgetOptions.temporalOption !== "none";
    const isGeographicalOptionNotNull = !(0, _LodashExtensions._isBlank)(this.state.widgetOptions.geographicalOption) && this.state.widgetOptions.geographicalOption !== "none";
    const isStatusOptionNull = !(0, _LodashExtensions._isBlank)(this.state.widgetOptions.statusOption) && this.state.widgetOptions.statusOption !== "none";
    const names = ['', ''];

    // title for graphs
    if (this.state.widgetChartIsActive) {
      // case of object distribution graph
      if (this.state.widgetOptions.graphOption === "objectDistribution") {
        names[0] = this.props.t(`octavi:widgets.${this.state.widgetOptions.objectOption}.distribution`);
        names[0] += " " + this.props.t(`octavi:widgets.${this.props.labelName}.aggregator`);
        names[0] = this.addOptionsTitle(names[0], false, isTemporalOptionNotNull, isGeographicalOptionNotNull);
        names[1] = this.props.t(`octavi:widgets.${this.state.widgetOptions.objectOption}.file`);
        names[1] += " " + this.props.t(`octavie:charts:by`);
        names[1] += " " + this.props.t(`octavi:widgets.${this.props.labelName}.file`);
        names[1] = this.addOptionFileName(names[1], false, isTemporalOptionNotNull, isGeographicalOptionNotNull);

        //case of spatial distribution graph
      } else if (this.state.widgetOptions.graphOption === "spatialDistribution") {
        names[0] = this.props.t(`octavi:widgets:spatial:distribution:${this.state.widgetOptions.geographicalOption}`).toLowerCase();
        names[0] += " (" + this.props.t(`octavi:widgetOptions:onLocationOption:${this.state.widgetOptions.onLocationOption}`).toLowerCase() + ")";
        names[0] += " " + this.props.t(`octavi:widgets.${this.props.labelName}.aggregator`);
        names[0] = this.addOptionsTitle(names[0], isObjectOptionNotNull, isTemporalOptionNotNull, false);
        names[1] = this.props.t(`octavi:widgets:spatial:file:${this.state.widgetOptions.geographicalOption}`);
        names[1] += " " + this.props.t(`octavie:charts:by`);
        names[1] += " " + this.props.t(`octavi:widgets.${this.props.labelName}.file`);
        names[1] += " " + this.props.t(`octavi:widgetOptions:onLocationOption:${this.state.widgetOptions.onLocationOption}`);
        names[1] = this.addOptionFileName(names[1], isObjectOptionNotNull, isTemporalOptionNotNull, false);

        // case of raw count or mean per day graph
      } else {
        //case of mean per day
        if (isObjectOptionNotNull || isTemporalOptionNotNull || isGeographicalOptionNotNull) {
          names[0] = this.props.t(`octavi:widgets.${this.props.labelName}.mean`);
          names[1] = this.props.t(`octavi:widgets.${this.props.labelName}.fileMean`);
          //case of total per day graph
        } else {
          names[0] = this.props.t(`octavi:widgets.${this.props.labelName}.count`);
          names[1] = this.props.t(`octavi:widgets.${this.props.labelName}.fileCount`);
        }

        // options part
        names[0] = this.addOptionsTitle(names[0], isObjectOptionNotNull, isTemporalOptionNotNull, isGeographicalOptionNotNull);
        names[1] = this.addOptionFileName(names[1], isObjectOptionNotNull, isTemporalOptionNotNull, isGeographicalOptionNotNull);
      }

      // title for number
    } else {
      // first title part
      if (isObjectOptionNotNull || isTemporalOptionNotNull || isGeographicalOptionNotNull || titleType === "mean") {
        names[0] = this.props.t(`octavi:widgets.${this.props.labelName}.mean`);
        names[1] = this.props.t(`octavi:widgets.${this.props.labelName}.fileMean`);
      } else {
        names[0] = this.props.t(`octavi:widgets.${this.props.labelName}.count`);
        names[1] = this.props.t(`octavi:widgets.${this.props.labelName}.fileCount`);
      }

      // options part
      names[0] = this.addOptionsTitle(names[0], isObjectOptionNotNull, isTemporalOptionNotNull, isGeographicalOptionNotNull, isStatusOptionNull);
      names[1] = this.addOptionFileName(names[1], isObjectOptionNotNull, isTemporalOptionNotNull, isGeographicalOptionNotNull, isStatusOptionNull);
    }
    if (periodStringName) {
      names[0] += " " + this.props.t(`octavi:widgets:${periodStringName}`);
      names[1] += " " + this.props.t(`octavi:widgets:${periodStringName}`);
    } else {
      names[0] += " " + this.props.t(`octavi:widgets:periodString`);
    }

    //file nams are made with camel case
    names[1] = (0, _lodash.camelCase)(names[1]);

    //add dates info to file names
    const idxFilterOne = (0, _utils.getFilterIdx)(this.state.filters, 'FilterOne');
    const idxFilterTwo = (0, _utils.getFilterIdx)(this.state.filters, 'FilterTwo');
    if (this.state.filters[idxFilterOne]['calendarStartAt'] && this.state.filters[idxFilterOne]['calendarEndAt']) {
      names[1] = this.addFilterFileName(names[1], this.state.filters[idxFilterOne]);
    }
    if (_OctaviParameters.default.comparisonIsSelected && this.state.filters[idxFilterTwo]['calendarStartAt'] && this.state.filters[idxFilterTwo]['calendarEndAt']) {
      names[1] = this.addFilterFileName(names[1], this.state.filters[idxFilterTwo]);
    }
    return names;
  }
  onDetailOpening() {
    this.setState({
      detailOpen: true
    });
  }
  onDetailClose() {
    this.setState({
      detailOpen: false
    });
  }
  widgetContent(type) {
    const idxFilterOne = (0, _utils.getFilterIdx)(this.state.filters, 'FilterOne');
    const idxFilterTwo = (0, _utils.getFilterIdx)(this.state.filters, 'FilterTwo');
    if (type == "number") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "oct_widget_content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "_full-width _space-around"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "_blue tr__widget__big-value _center"
      }, /*#__PURE__*/_react.default.createElement(_OctaviComponent.OctaviFilterResult, {
        value: this.state[`value${idxFilterOne}`]
      })), this.state.comparisonIsSelected && /*#__PURE__*/_react.default.createElement("span", {
        className: "tr__widget__big-value _center"
      }, /*#__PURE__*/_react.default.createElement(_OctaviComponent.OctaviFilterResult, {
        value: this.state[`value${idxFilterTwo}`]
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "_full-width _space-around"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "_pale _blue"
      }, this.state.comparisonIsSelected ? this.props.t('octavi:filters:comparison:filterOne') : this.props.t(`octavi:widgets.${this.props.labelName}.object`)), this.state.comparisonIsSelected && /*#__PURE__*/_react.default.createElement("span", {
        className: "_pale"
      }, this.props.t('octavi:filters:comparison:filterTwo'))), !(0, _LodashExtensions._isBlank)(this.props.subtitle) && /*#__PURE__*/_react.default.createElement("p", {
        className: "tr__widget__big-value-subtitle"
      }, this.props.subtitle), (this.props.countPerWeekday || this.props.countPerHour) && /*#__PURE__*/_react.default.createElement(_reactCollapsible.default, {
        trigger: "+",
        open: false,
        transitionTime: 100,
        onOpening: this.onDetailOpening,
        onClose: this.onDetailClose
      }, this.props.countPerWeekday && /*#__PURE__*/_react.default.createElement(_PeriodCount.default, {
        period: "dow",
        t: this.props.t,
        i18n: this.props.i18n,
        object: this.props.object,
        customFilterString: this.props.customFilterString ? this.props.customFilterString : "",
        labelName: this.props.labelName,
        title: this.getTitle("dowString", "mean")[0],
        fileName: this.getTitle("dowString", "mean")[1],
        type: this.props.type,
        widgetSpecs: this.props.widgetSpecs,
        parentUuid: this.props.uuid
      }), this.props.countPerHour && /*#__PURE__*/_react.default.createElement(_PeriodCount.default, {
        period: "hour",
        t: this.props.t,
        i18n: this.props.i18n,
        object: this.props.object,
        customFilterString: this.props.customFilterString ? this.props.customFilterString : "",
        labelName: this.props.labelName,
        title: this.getTitle("hourString", "mean")[0],
        fileName: this.getTitle("hourString", "mean")[1],
        type: this.props.type,
        widgetSpecs: this.props.widgetSpecs,
        parentUuid: this.props.uuid
      })));
    } else if (type == "chart") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "box",
        key: JSON.stringify(this.state)
      }, /*#__PURE__*/_react.default.createElement(_Chart.default, {
        t: this.props.t,
        i18n: this.props.i18n,
        size: "small",
        fileName: this.getTitle()[1],
        data: this.state.comparisonIsSelected ? {
          valueFilterOne: this.state[`value${idxFilterOne}`],
          valueFilterTwo: this.state[`value${idxFilterTwo}`]
        } : {
          valueFilterOne: this.state[`value${idxFilterOne}`]
        },
        name: `${this.props.labelName}`,
        filter: (0, _utils.buildWidgetFilter)(this.state.filters, 'FilterOne', this.props.object, this.state.widgetOptions) //
        ,
        generateOptions: this.state.widgetOptions.graphOption && (this.state.widgetOptions.graphOption === "objectDistribution" || this.state.widgetOptions.graphOption === "spatialDistribution") ? _distributionChartOptions.default : _columnChartOptions.default
      }));
    }
  }
  renderWidget() {
    const idxFilterOne = (0, _utils.getFilterIdx)(this.state.filters, 'FilterOne');
    const idxFilterTwo = (0, _utils.getFilterIdx)(this.state.filters, 'FilterTwo');
    if ((0, _LodashExtensions._isBlank)(this.state[`value${idxFilterOne}`]) || this.state.comparisonIsSelected == true && ((0, _LodashExtensions._isBlank)(this.state[`value${idxFilterOne}`]) || (0, _LodashExtensions._isBlank)(this.state[`value${idxFilterTwo}`]))) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "tr__widget__header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "widget_title_width"
    }, /*#__PURE__*/_react.default.createElement("h3", null, this.getTitle()[0])), /*#__PURE__*/_react.default.createElement("div", {
      className: "widget_button_width"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "button grey",
      type: "button",
      onClick: x => this.onSettingsButtonClick()
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: `_icon chart_line_white`,
      src: "/dist/images/icons/octavi/settings_white.svg",
      alt: "settings"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "widget_button_width"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "button grey",
      type: "button",
      onClick: x => this.onChartButtonClick()
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: `_icon chart_line_white`,
      src: this.state.widgetChartIsActive ? `/dist/images/icons/octavi/number_white.svg` : `/dist/images/icons/octavi/chart_line_white.svg`,
      alt: this.state.widgetChartIsActive ? `number` : `graph`
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "widget_button_width"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "button grey",
      type: "button",
      onClick: () => this.onRefreshClick()
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faSync.faSync,
      className: 'icon_white'
    })))), this.state.widgetChartIsActive ? this.widgetContent("chart") : this.widgetContent("number"), /*#__PURE__*/_react.default.createElement(_WidgetOptionsSelector.default, {
      id: `widgetOptionManager`,
      uuid: this.props.uuid,
      t: this.props.t,
      i18n: this.props.i18n,
      object: this.props.object,
      labelName: this.props.labelName,
      allowStatus: !(0, _LodashExtensions._isBlank)(this.props.widgetSpecs.allowStatus) ? this.props.widgetSpecs.allowStatus : true
    }));
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `tr__widget__container _position_relative ${this.state.detailOpen ? "_big_height" : ""}`
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "widget_delete_button",
      onClick: x => this.onDeleteButtonClick()
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/dist/images/icons/octavi/close_white.svg",
      alt: "delete",
      style: {
        width: "90%"
      }
    })), this.renderWidget());
  }
}
var _default = exports.default = (0, _reactI18next.withTranslation)()(TotalCountWidget);